import { useAuth0 } from "@auth0/auth0-react";
import { useMutation } from "@tanstack/react-query";
import { updateUserAccountId } from "../api/global_collections/users";

export const useGlobalUserAccountUpdate = () => {
  const auth0 = useAuth0();
  return useMutation({
    mutationFn: ({ userId, newAccountId }: { userId: string; newAccountId: string }) =>
      updateUserAccountId(userId, newAccountId, auth0),
  });
}; 